import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const FaqHome: React.FC<SvgIconDefaultProps> = ({ className, testId }) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.6665 18.5999C6.43317 18.5999 6.19149 18.5416 5.97482 18.425C5.49982 18.175 5.20817 17.6749 5.20817 17.1416V15.9583C2.6915 15.7 1.0415 13.8499 1.0415 11.1999V6.19999C1.0415 3.33333 2.9665 1.40833 5.83317 1.40833H14.1665C17.0332 1.40833 18.9582 3.33333 18.9582 6.19999V11.1999C18.9582 14.0666 17.0332 15.9916 14.1665 15.9916H11.0248L7.47481 18.3583C7.23315 18.5167 6.94984 18.5999 6.6665 18.5999ZM5.83317 2.64998C3.68317 2.64998 2.2915 4.04165 2.2915 6.19165V11.1917C2.2915 13.3417 3.68317 14.7334 5.83317 14.7334C6.17484 14.7334 6.45817 15.0167 6.45817 15.3584V17.1334C6.45817 17.2417 6.52484 17.2917 6.56651 17.3167C6.60817 17.3417 6.69152 17.3667 6.78318 17.3083L10.4915 14.8417C10.5915 14.775 10.7165 14.7334 10.8415 14.7334H14.1748C16.3248 14.7334 17.7165 13.3417 17.7165 11.1917V6.19165C17.7165 4.04165 16.3248 2.64998 14.1748 2.64998H5.83317Z"
        fill="#5C5C5C"
      />
      <path
        d="M10 10.0917C9.65834 10.0917 9.37501 9.80834 9.37501 9.46667V9.29171C9.37501 8.32504 10.0833 7.85003 10.35 7.6667C10.6583 7.45836 10.7583 7.3167 10.7583 7.10004C10.7583 6.68337 10.4167 6.34167 10 6.34167C9.58334 6.34167 9.2417 6.68337 9.2417 7.10004C9.2417 7.4417 8.95837 7.72504 8.6167 7.72504C8.27503 7.72504 7.9917 7.4417 7.9917 7.10004C7.9917 5.9917 8.89168 5.09167 10 5.09167C11.1083 5.09167 12.0083 5.9917 12.0083 7.10004C12.0083 8.05004 11.3084 8.52502 11.05 8.70002C10.725 8.91669 10.625 9.05837 10.625 9.29171V9.46667C10.625 9.81667 10.3417 10.0917 10 10.0917Z"
        fill="#5C5C5C"
      />
      <path
        d="M10 12.1667C9.65 12.1667 9.375 11.8834 9.375 11.5417C9.375 11.2 9.65833 10.9167 10 10.9167C10.3417 10.9167 10.625 11.2 10.625 11.5417C10.625 11.8834 10.35 12.1667 10 12.1667Z"
        fill="#5C5C5C"
      />
    </CustomSvg>
  );
};

export default FaqHome;
